import { useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { EventEditor } from "@/components/admin/EventEditor";

const blank = { title: "", slug: "", eyebrow: "", tagline: "", schedule_note: "", location: "", image: "", secondary_image: "",
  story_title: "", story: "", about_title: "", about: "", disclaimer: "", service_fee: 0, published: false, featured: false,
  acts: [], private_options: [], verdict: null, ticket_types: [], nights: [] };

export const AdminEvents = ({ headers, events, reload }) => {
  const [editing, setEditing] = useState(null);

  const save = async (data) => {
    try {
      if (data.id) await api.put(`/admin/events/${data.id}`, data, { headers });
      else await api.post("/admin/events", data, { headers });
      toast.success("Event saved");
      setEditing(null);
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const remove = async (ev) => {
    if (!window.confirm(`Delete "${ev.title}"? This can't be undone.`)) return;
    try {
      await api.delete(`/admin/events/${ev.id}`, { headers });
      toast.success("Event deleted");
      reload();
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (editing) return <EventEditor initial={editing} onCancel={() => setEditing(null)} onSave={save} />;

  return (
    <div className="mt-6 space-y-4" data-testid="admin-events">
      <button type="button" onClick={() => setEditing(blank)} data-testid="new-event-button" className="inline-flex items-center gap-2 rounded bg-[#141210] px-5 py-3 text-xs font-semibold uppercase tracking-widest text-[#F3DDA4] hover:bg-[#2A2520]"><Plus className="h-4 w-4" />New event</button>
      {events.map((ev) => {
        const seats = ev.nights.reduce((s, n) => s + n.capacity, 0);
        const sold = ev.nights.reduce((s, n) => s + n.sold, 0);
        return (
          <div key={ev.id} className="flex flex-wrap items-center justify-between gap-4 border border-[#E5DACA] rounded-lg bg-white p-5" data-testid={`admin-event-${ev.slug}`}>
            <div>
              <p className="font-display text-xl text-[#1F1B17]">{ev.title}</p>
              <p className="mt-1 text-xs text-[#6B6157]">{ev.published ? "Published" : "Draft"}{ev.featured ? " · Featured" : ""} · {ev.nights.length} nights · {sold}/{seats} seats sold · /{ev.slug}</p>
            </div>
            <div className="flex gap-2">
              <button type="button" onClick={() => setEditing(ev)} data-testid={`edit-event-${ev.slug}`} className="inline-flex items-center gap-2 border border-[#1F1B17] px-4 py-2 text-xs uppercase tracking-widest text-[#A8832F] hover:bg-[#F1E9DA]"><Pencil className="h-3.5 w-3.5" />Edit</button>
              <button type="button" onClick={() => remove(ev)} data-testid={`delete-event-${ev.slug}`} className="border border-red-500/30 px-3 py-2 text-red-600 hover:bg-red-500/10" aria-label="Delete"><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
